import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { Col, Row } from "react-bootstrap";
import Cookies from "universal-cookie";
import moment from "moment";
import axios from "axios";

import { TableHeaderColumn } from "react-bootstrap-table";
const readCookie = require("../cookie.js").readCookie;

const { SearchBar } = Search;
const cookies = new Cookies();

const BasicProfile = () => {
  // const ApiUrl=process.env.REACT_APP_API_APP_FIELD_URL;
  const [basicProfiles, setBasicProfiles] = useState([]);

  const basicColumns = [
    {
      text: "S.No.",
      sort: true,
      hidden: false,
      searchable: true,
      headerStyle: () => {
        return { width: "40px" };
      },
      dataField: "id",
      //count the  number of rows
      export: true,
      formatter: (cell, row, index) => {
        return index + 1;
      },
    },
    {
      dataField: "full_name",
      text: "Full Name",
      sort: true,
      headerStyle: () => {
        return { width: "150px" };
      },
      formatter: (cell) => cell || "-",
    },
    {
      dataField: "mobile_number",
      text: "Phone",
      sort: true,
      headerStyle: () => {
        return { width: "110px" };
      },
      formatter: (cell) => cell?.toString() || "-",
    },
    {
      dataField: "mobileNumberType",
      text: "Mobile Type",
      sort: true,
      headerStyle: () => {
        return { width: "110px" };
      },
      formatter: (cell) => cell || "-",
      hidden: true,
    },
    {
      dataField: "father_name",
      text: "Father's Name",
      sort: true,
      headerStyle: () => {
        return { width: "150px" };
      },
      formatter: (cell) => cell || "-",
      hidden: true,
    },
    {
      dataField: "education",
      text: "Education",
      sort: true,
      headerStyle: () => {
        return { width: "110px" };
      },
      formatter: (cell) => cell || "-",
      hidden: true,
    },
    {
      dataField: "gender",
      text: "Gender",
      sort: true,
      headerStyle: () => {
        return { width: "80px" };
      },
    },
    {
      dataField: "dob",
      text: "Age",
      sort: true,
      headerStyle: () => {
        return { width: "100px" };
      },
      formatter: (cell, row) => {
        let age = row?.dob ?? "";
        if (age) {
          let dob = new Date(age);
          let diff_ms = Date.now() - dob.getTime();
          let age_dt = new Date(diff_ms);
          let formatted_dob =
            dob.getDate() +
            "-" +
            (dob.getMonth() + 1) +
            "-" +
            dob.getFullYear();
          return Math.abs(age_dt.getUTCFullYear() - 1970);
        }
        return "-";
      },
    },
    {
      dataField: "category",
      text: "Category",
      sort: true,
      headerStyle: () => {
        return { width: "80px" };
      },
      hidden: true,
    },
    {
      dataField: "state",
      text: "State",
      sort: true,
      formatter: (cell) => cell || "-",
      headerStyle: () => {
        return { width: "150px" };
      },
    },
    {
      dataField: "district",
      text: "District",
      sort: true,
      formatter: (cell) => cell || "-",
      headerStyle: () => {
        return { width: "150px" };
      },
    },
    {
      dataField: "village_name",
      text: "Village",
      sort: true,
      formatter: (cell) => cell || "-",
      headerStyle: () => {
        return { width: "150px" };
      },
    },
    {
      dataField: "block",
      text: "Block",
      sort: true,
      formatter: (cell) => cell || "-",
      headerStyle: () => {
        return { width: "150px" };
      },
    },
    {
      dataField: "aadhar_number",
      text: "Aadhaar Number",
      sort: true,
      formatter: (cell) => cell?.toString() || "-",
      headerStyle: () => {
        return { width: "150px" };
      },
    },
    {
      dataField: "srlm_associated",
      text: "SRLM Associated",
      sort: true,
      formatter: (cell) => (cell ? "Yes" : "No"),
      headerStyle: () => {
        return { width: "150px" };
      },
    },
    {
      dataField: "shgId",
      text: "SHG ID",
      sort: true,
      formatter: (cell) => cell || "-",
      headerStyle: () => {
        return { width: "250px" };
      },
      hidden: true,
    },
    {
      dataField: "voId",
      text: "VO ID",
      sort: true,
      formatter: (cell) => cell || "-",
      headerStyle: () => {
        return { width: "250px" };
      },
      hidden: true,
    },
    {
      dataField: "clfId",
      text: "CLF ID",
      sort: true,
      formatter: (cell) => cell || "-",
      headerStyle: () => {
        return { width: "250px" };
      },
      hidden: true,
    },
    {
      dataField: "disability",
      text: "Disability (PWD)",
      sort: true,
      headerStyle: () => {
        return { width: "100px" };
      },
      formatter: (cell) => (cell ? "Yes" : "No"),
      hidden: true,
    },
    {
      dataField: "created_by",
      text: "Created By",
      sort: true,
      formatter: (cell) => cell || "-",
      headerStyle: () => {
        return { width: "250px" };
      },
      hidden: true,
    },
    {
      dataField: "created_at",
      text: "Created At",
      sort: true,
      formatter: (cell) =>
        cell ? moment(cell).format("DD-MM-YYYY HH:mm") : "-",
      headerStyle: () => {
        return { width: "250px" };
      },
    },
    {
      dataField: "updated_at",
      text: "Updated At",
      sort: true,
      formatter: (cell) =>
        cell ? moment(cell).format("DD-MM-YYYY HH:mm") : "-",
      headerStyle: () => {
        return { width: "250px" };
      },
      hidden: true,
    },
    {
      dataField: "survey_done",
      text: "Survey Done",
      sort: true,
      formatter: (cell) => (cell ? "Yes" : "No"),
      headerStyle: () => {
        return { width: "100px" };
      },
    },
    {
      dataField: "_id",
      text: "ID",
      hidden: true,
    },
  ];

  const fetchBasicLeads = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_APP_FIELD_URL}/surveys/bp/admin-base-profile`,
        {
          headers: {
            source: "humblebee_admin",
            Authorization: "Bearer " + JSON.parse(readCookie("access_token")),
          },
        }
      );
      console.log("Basic Leads Profile:-", response.data);
      setBasicProfiles(response.data.data || []);
    } catch (error) {
      console.error("Error fetching basic leads:", error);
    }
  };

  useEffect(() => {
    fetchBasicLeads();
    console.log("Basic Profiles Data:", basicProfiles);
  }, []);

  return (
    <div className="page-container leads-page">
      <h2>Basic Profiles</h2>

      <div styel="flex">
        <p>Total Basic Profiles:{basicProfiles.length}</p>
        <p>
          Advanced Surveyed Profiles:
          {basicProfiles.filter((item) => item.survey_done).length}
        </p>
        <p>
          Advanced Surveyed Profiles:
          {basicProfiles.filter((item) => !item.survey_done).length}
        </p>
      </div>

      <ToolkitProvider
        keyField="_id"
        data={basicProfiles}
        columns={basicColumns}
        search
      >
        {(toolkitProps) => (
          <PaginationProvider
            pagination={paginationFactory({
              custom: true,
              totalSize: basicProfiles.length,
              sizePerPageList: [100, 200, 300, 400].map((n) => ({
                text: n.toString(),
                value: n,
              })),
              showTotal: true,
            })}
          >
            {({ paginationProps, paginationTableProps }) => (
              <>
                <Row className="mb-3 align-items-center">
                  <Col md={4}>
                    <SearchBar
                      {...toolkitProps.searchProps}
                      placeholder="Search..."
                      className="form-control"
                    />
                  </Col>
                </Row>

                <BootstrapTable
                  {...toolkitProps.baseProps}
                  {...paginationTableProps}
                  striped
                  hover
                  condensed
                  noDataIndication="No profiles found"
                />

                <Row className="mt-3">
                  <Col className="d-flex">
                    <SizePerPageDropdownStandalone {...paginationProps} />
                  </Col>
                  <Col className="d-flex">
                    <PaginationListStandalone {...paginationProps} />
                  </Col>
                </Row>
              </>
            )}
          </PaginationProvider>
        )}
      </ToolkitProvider>
    </div>
  );
};

export default BasicProfile;
